<template>
  <div v-if="item">
    <div class="row">
      <div class="col-xl-6">
        <b-card
          :title="item.name"
          :img-src="getImage()"
          img-alt="Image"
          img-top
          bg-variant="dark"
          text-variant="light"
          class="m-b-20"
        >
          <b-card-text>{{ item.description }} </b-card-text>
        </b-card>
      </div>
      <div class="col-xl-6">
        <b-card
          class="m-b-20"
          header-tag="header"
          header-bg-variant="dark"
          header-text-variant="light"
        >
          <template v-slot:header>
            <h6 class="mb-0">Details</h6>
          </template>
          <b-card-text>
            <b>Name: </b><span>{{ item.name }}</span
            ><br />
            <b>{{ mainCategoryTitle }}: </b>
            <span v-if="item.category">
              <a
                v-bind:href="
                  categoryLink(
                    this.getMainCategory(item.category.parent, false)
                  )
                "
                class="text-black"
              >
                {{ this.getMainCategory(item.category.parent) }}
              </a>
            </span>
            <span v-else>None</span> <br />
            <b>{{ subcategoryTitle }}: </b>
            <span v-if="item.category">
              <a v-bind:href="categoryLink(item.category)" class="text-black">
                {{ item.category.name }}
              </a>
            </span>
            <span v-else>None</span> <br />
            <b>Source: </b>{{ item.source }} <br />
            <b>Total: </b>{{ item.amount }} {{ item.unit }} <br />
            <b>Unit price: </b>{{ item.unitPrice }}
          </b-card-text>
        </b-card>
        <b-card
          class="m-b-20"
          header-tag="header"
          header-bg-variant="dark"
          header-text-variant="light"
        >
          <template v-slot:header>
            <h6 class="mb-0">Script data</h6>
          </template>
          <b-card-text>
            <div>
              <b>Number of active items: </b><span>{{ activeNumber }}</span
              ><br />
              <b>Storyboards where used: </b>
              <p v-if="!storyboardsWhereUsed.length">None</p>
              <ul>
                <li
                  v-for="storyboard in storyboardsWhereUsed"
                  :key="storyboard.id"
                >
                  <a
                    v-bind:href="`/storyboard/${storyboard.id}`"
                    class="text-black"
                  >
                    {{ storyboard.name }}
                  </a>
                </li>
              </ul>
              <b>Stages where used: </b>
              <p v-if="!stagesWhereUsed.length">None</p>
              <ul>
                <li v-for="stage in stagesWhereUsed" :key="stage.id">
                  <a
                    v-bind:href="`/storyboard/${stage.storyboard}/stage/${stage.id}`"
                    class="text-black"
                  >
                    {{ stage.name }}
                  </a>
                </li>
              </ul>
              <b>Steps where used: </b>
              <p v-if="!stepsWhereUsed.length">None</p>
              <ul>
                <li
                  class="m-b-20"
                  v-for="step in stepsWhereUsed"
                  :key="step.id"
                >
                  {{ step.name }}
                  <url-button
                    label="Go to"
                    :url="`/script/space/` + step.id"
                    class="btn-yellow btn-sm pull-right"
                  />
                </li>
              </ul>
            </div>
          </b-card-text>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6">
        <b-card
          class="m-b-20"
          header-tag="header"
          header-bg-variant="dark"
          header-text-variant="light"
        >
          <template v-slot:header>
            <h6 class="mb-0">Files</h6>
          </template>
          <b-card-text>
            <vue-custom-scrollbar class="height-sm">
              <div class="row">
                <div
                  class="m-20 text-center"
                  v-for="file in item.files"
                  :key="file.id"
                >
                  <a
                    :href="fileUrl + file.fileFd"
                    :download="file.name"
                    target="_blank"
                  >
                    <i
                      v-if="fileType(file.fileFd) == 'pdf'"
                      class="fas fa-file-pdf fa-5x"
                    />
                    <i
                      v-else-if="fileType(file.fileFd) == ('jpg' || 'jpeg')"
                      class="fas fa-file-image fa-5x"
                    />
                    <p class="text-black">{{ file.name }}</p>
                  </a>
                </div>
              </div>
              <div v-if="!item.files.length">
                <p class="m-l-10">No files</p>
              </div>
            </vue-custom-scrollbar>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-xl-6">
        <b-card
          class="m-b-20"
          header-tag="header"
          header-bg-variant="dark"
          header-text-variant="light"
        >
          <template v-slot:header>
            <h6 class="mb-0">Notes</h6>
          </template>
          <b-card-text>
            <vue-custom-scrollbar class="height-sm">
              <ul class="media-list media-list-with-divider media-messaging">
                <li
                  class="media media-sm"
                  v-for="(note, index) in item.notes"
                  :key="note.id"
                >
                  <div class="media-body">
                    <h5 class="media-heading">Note #{{ index + 1 }}</h5>
                    <p>{{ note.content }}</p>
                  </div>
                </li>
                <li v-if="!item.notes.length" class="media media-sm">
                  <div class="media-body">
                    <p>No notes</p>
                  </div>
                </li>
              </ul>
            </vue-custom-scrollbar>
          </b-card-text>
        </b-card>
      </div>
    </div>
    <b-card
      class="m-b-20"
      header-tag="header"
      header-bg-variant="dark"
      header-text-variant="light"
    >
      <template v-slot:header>
        <h6 class="mb-0">Actions</h6>
      </template>
      <url-button
        class="btn-secondary"
        label="Back to list"
        :url="`/eventbank/${$route.params.type}/items`"
      />
      <b-button v-b-modal.modalAlert class="btn btn-danger pull-right"
        >Delete</b-button
      >
      <url-button
        class="btn-white pull-right"
        label="Make a copy"
        :url="`/eventbank/${$route.params.type}/items/${$route.params.id}/copy`"
      />
      <url-button
        class="btn-white pull-right"
        label="Edit"
        :url="`/eventbank/${$route.params.type}/items/${$route.params.id}/edit`"
      />
      <b-button @click="addToScript" class="btn-yellow pull-right mr-1"
        >Add to script</b-button
      >
    </b-card>

    <b-modal
      id="modalAlert"
      :title="'Delete ' + item.name"
      centered
      cancel-variant="white"
      ok-variant="danger"
      ok-title="Delete"
      v-on:ok="deleteItem"
    >
      <div class="alert alert-danger m-b-0">
        <h5><i class="fa fa-info-circle"></i>Delete</h5>
        <p>Are you sure you want to delete {{ item.name }} ?</p>
      </div>
    </b-modal>

    <add-to-script-modal
      ref="childModal"
      :itemToAdd="item"
      :itemsToAdd="null"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import UrlButton from '../buttons/UrlButton.vue'
import AddToScriptModal from './AddToScriptModal.vue'

export default {
  name: 'Item',
  props: ['typeId', 'item', 'categories', 'scriptItems', 'activeEvent'],
  components: {
    UrlButton,
    AddToScriptModal
  },
  data() {
    return {
      mainCategoryTitle: 'Service category',
      subcategoryTitle: 'Service area',
      activeNumber: 0,
      stepsWhereUsed: [],
      stagesWhereUsed: [],
      storyboardsWhereUsed: [],
      image: null,
      imageElement: null,
      imageUrl: process.env.VUE_APP_API_URL + '/uploads/images/',
      fileUrl: process.env.VUE_APP_API_URL + '/uploads/files/'
    }
  },
  computed: {
    ...mapState('storyboard', ['storyboards']),
    ...mapState('stage', ['stages']),
    ...mapState('step', ['steps'])
  },
  methods: {
    ...mapActions('storyboard', ['getStoryboards']),
    ...mapActions('stage', ['getStages']),
    ...mapActions('step', ['getSteps']),
    getMainCategory(parentCategoryId, nameOnly = true) {
      let returnValue = 'None'
      this.categories.forEach((category) => {
        if (category.id == parentCategoryId) {
          if (nameOnly) {
            returnValue = category.name
          } else {
            returnValue = category
          }
        }
      })
      return returnValue
    },
    getImage() {
      if (this.item.image) {
        return this.imageUrl + this.item.image.imageFd
      } else {
        return require('../../assets/images/no_image.jpg')
      }
    },
    getUsage(currentItemId) {
      let stepArray = []
      let stageArray = []
      let storyboardArray = []
      this.scriptItems.forEach((scriptItem) => {
        if (scriptItem.item.id == currentItemId) {
          let hasStage
          let hasStoryboard
          this.steps.forEach((step) => {
            if (step.stage && step.id == scriptItem.step.id) {
              hasStage = true
              stepArray.push(step)
              this.stages.forEach((stage) => {
                if (stage.storyboard && stage.id == step.stage) {
                  hasStoryboard = true
                  stageArray.push(stage)
                  this.storyboards.forEach((storyboard) => {
                    if (storyboard.id == stage.storyboard) {
                      storyboardArray.push(storyboard)
                    }
                  })
                }
              })
            }
          })
          if (hasStage && hasStoryboard) {
            this.activeNumber += scriptItem.amount
          }
        }
      })
      this.stepsWhereUsed = [...new Set(stepArray)]
      this.stagesWhereUsed = [...new Set(stageArray)]
      this.storyboardsWhereUsed = [...new Set(storyboardArray)]
    },
    deleteItem() {
      if (this.item.image) {
        this.$parent.removeImage(this.item.image.id)
      }
      this.item.files.forEach((file) => {
        this.$parent.removeFile(file.id)
      })
      this.$parent.delete(this.item.id)
    },
    fileType(path) {
      return path.slice(path.lastIndexOf('.') + 1)
    },
    addToScript() {
      this.$refs['childModal'].$refs['modalAdd'].show()
    },
    categoryLink(item) {
      let type = item.type
      if (typeof type === 'number') {
        type = this.$store.state.type.types.find((t) => t.id === item.type)
      }
      return type == undefined
        ? ''
        : '/eventbank/' + type.name.toLowerCase() + '/categories/' + item.id
    }
  },
  created() {
    this.$parent.getItemCall()
    this.$store.dispatch('type/getTypes')
    this.getStoryboards(this.activeEvent.id)
    this.getStages(this.activeEvent.id)
    this.getSteps(this.activeEvent.id)
  },
  watch: {
    typeId: function () {
      switch (this.typeId) {
        case 1:
          this.mainCategoryTitle = 'Service category'
          this.subcategoryTitle = 'Service area'
          break
        case 2:
          this.mainCategoryTitle = 'Venue'
          this.subcategoryTitle = 'Area'
          break
        case 3:
          this.mainCategoryTitle = 'Group'
          this.subcategoryTitle = 'Team'
          break
        case 4:
          this.mainCategoryTitle = 'Main category'
          this.subcategoryTitle = 'Subcategory'
          break
        default:
          break
      }
    },
    steps: function () {
      if (this.item && !this.stepsWhereUsed.length) {
        this.getUsage(this.item.id)
      }
    }
  }
}
</script>
